export const SET_LOGIN_DATA = 'SET_LOGIN_DATA'
export const CLEAR_LOGIN_DATA = 'CLEAR_LOGIN_DATA'

export const setLoginData = (access_token, username, premium) => ({type: SET_LOGIN_DATA, access_token, username, premium})
export const clearLoginData = () => ({type: CLEAR_LOGIN_DATA})